import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 13.862a6.52 6.52 0 0 1-6.077-4.16 6.519 6.519 0 0 1 12.154 0A6.52 6.52 0 0 1 10 13.862m0-9.819a8.02 8.02 0 0 0-7.585 5.416.75.75 0 0 0 0 .487 8.019 8.019 0 0 0 15.17 0 .75.75 0 0 0 0-.487A8.02 8.02 0 0 0 10 4.043M9.99 7.844a1.858 1.858 0 1 0 0 3.716h.015a1.858 1.858 0 1 0 0-3.716z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }